import React, { FC } from 'react';
import PropTypes from 'prop-types';

import './../../css/Modal.scss';

import Button from '../Button/Button';

const Modal = ({ handleSubmit, handleClose, show, children, submitButtonText }) => {
    const showHideClassName: string = show ? 'modal display-block' : 'modal display-none';

    return (
        <div className={showHideClassName}>
            <section className="modal-main flex flex-col justify-center items-center">
                {children}
                <div className="flex-row flex-auto pb-4 mx-4">
                    {handleSubmit === undefined ? null : <Button onClick={handleSubmit}>{submitButtonText}</Button>}
                    &nbsp;&nbsp;&nbsp;
                    <Button onClick={handleClose}>{submitButtonText === 'Yes' ? 'No' : 'Close'}</Button>
                </div>
            </section>
        </div>
    );
};

Modal.propTypes = {
    handleClose: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    children: PropTypes.any,
    handleSubmit: PropTypes.any,
    submitButtonText: PropTypes.any
};

export default Modal;
